//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';
import { PaymentSourceRegistrationNextAction } from './Enums';

export class SubscriptionResultItem extends ItemBase {
    NextAction: PaymentSourceRegistrationNextAction = PaymentSourceRegistrationNextAction.None;
    StripeCustomerID: string | null = null;
    StripeClientSecret: string | null = null;
    StripeSubscriptionID: string | null = null;

    constructor(initializer?: Partial<SubscriptionResultItem>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "SubscriptionResultItem";
}
